<div class="white-bg-overlay">&nbsp;</div>
<section class="page-wrapper bg-white scroll-container">
  <div class="d-flex pt-1">
    <div class="me-auto">
      <h1 class="page-title">Clients Hub</h1>
    </div>
    <div class="title-bar-btn">
      <button
        cpGTagEvent
        [params]="{ event_label: 'client_list_add_client' }"
        class="btn btn-primary">
        <i class="fas fa-xs fa-plus"></i>&nbsp;Add Client
      </button>
    </div>
    <lib-search></lib-search>
  </div>
  <div *ngIf="!clients || clients.length <= 0">
    <em>No clients to display</em>
  </div>
  <div *ngIf="clients && clients.length > 0">
    <table class="table table-border">
      <thead>
        <tr>
          <th style="width: 50px"></th>
          <th>Name</th>
          <th>Company ID</th>
          <th>Legal Name</th>
          <th>Primary Contact</th>
          <th>Contact Email</th>
          <th>Contact Phone</th>
          <th class="text-center">Note</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let client of clients">
          <td><i class="far fa-3x fa-building"></i></td>
          <td>
            <a (click)="navigateToClient(client.Id)">
              <strong>{{ client.DBA || client.Name }}</strong>
            </a>
          </td>
          <td>{{ client.Id }}</td>
          <td>{{ client.Name }}</td>
          <td>{{ client.PrimaryContact }}</td>
          <td>
            <a>{{ client.ContactEmail }}</a>
          </td>
          <td>{{ client.ContactPhone | mask: '(000) 000-0000' }}</td>
          <td class="text-center">
            <a (click)="navigateToClientNotes(client.Id)">
              <i class="far fa-comment-alt"></i>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
    <lib-pagination (pageChanged)="loadPage($event)" [pagination]="pagination"></lib-pagination>
  </div>
</section>
